import DictionaryAPI from "api/DictionaryAPI";
import useFetchData from "hooks/useFetchData";

export default function useDocumentTypesBrief() {
   return useFetchData({
      APIMethod: DictionaryAPI.getDocumentTypes
   })
}